import React from "react";
import "./style.css";

const ProgressCrowdfund = ({ raised, goal, currency = "EUR" }) => {
  const percent = Math.min(100, Math.round((raised / goal) * 100));

  const fmt = (v) =>
    new Intl.NumberFormat(undefined, { style: "currency", currency }).format(v);

  return (
    <div className="progress-container align-center">
      <div className="progress-header">
        <span>{fmt(raised)} angariados</span>
        <span>{fmt(goal)} objetivo</span>
      </div>

      <div className="progress-bar">
        <div className="progress-fill" style={{ width: `${percent}%` }}>
          {percent}%
        </div>
      </div>
    </div>
  )
}

export default ProgressCrowdfund;
